module.exports = __webpack_public_path__ + "static/media/Editing.ad842963.svg";